import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { getTaskRequestHoursAsync, checkedState, unCheckedState, checkedAllState, unCheckedAllState } from './taskRequestHoursSlice';
import { Link } from 'react-router-dom';
import { KTIcon } from '../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../common/SweetAlert';
import CustomPagination from "../../common/Pagination";
import { ShowToast } from '../../common/Toastr';
import clsx from "clsx";
import { FormatInvoiceDecimalNumber, getValueFromResource } from '../../common/timeLiveFunction';

const itemClass = 'ms-1 ms-lg-0';

const TaskRequestHoursItem = (props: any) => {
    const { taskRequestHoursList, modelRef, t, onopenModal, oncloseModal } = props;
    const dispatch = useAppDispatch();
    const { isLoading } = useAppSelector((state) => state.taskRequestHours);
   const { decimalPlaces, cultureInfoName } = useAppSelector((state) => state.globalState)


    const renderStatusExpenseEntries = (selectedRow: any) => {
        let status: any = "";
      if (selectedRow.Status == "Approved") {
            status = (
                <span className="badge badge-light-success fs-7">
                    Approved
                </span>
            )
        }
        else if (selectedRow.Status == "Rejected") {
            status = (
                <span className="badge badge-light-danger fs-7">
                    Rejected
                </span>
            )
        }
        else if (selectedRow.Status == "Pending") {
            status = (
                <span className="badge badge-light-warning fs-7">
                    Pending
                </span>
            )
        }
        return status;
    }

    return (
        <>
             <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' >
                <thead>
                    <tr className="thHeading align-middle " >
                        <th className='w-25' >
                            {/* {t('Task Name')} */}
                            {getValueFromResource('Task Name',dispatch, t)}
                        </th>
                        <th className='w-25' style={{textAlign:'center'}}>
                            {/* {t('Previous Allocation Hours')} */}
                            {getValueFromResource('Previous Allocation Hours',dispatch, t)}
                            </th>
                        <th className='w-25' style={{textAlign:'center'}}>
                            {/* {t('Requested Hours')} */}
                            {getValueFromResource('Requested Hours',dispatch, t)}
                            </th>
                        <th className='w-25' style={{textAlign:'center'}}>
                            {/* {t('Request Status')} */}
                            {getValueFromResource('Request Status',dispatch, t)}
                            </th>
                    </tr>
                </thead>
                <tbody>
                   
                    {taskRequestHoursList.length > 0 && taskRequestHoursList.map((taskRequestHours: any, i: any) => (
                        <tr key={i}  style={{ height:42 }}>
                            <td>
                            {taskRequestHours.TaskName}
                            </td>
                            <td style={{textAlign:'center'}}>
                            {FormatInvoiceDecimalNumber(cultureInfoName.toString(),taskRequestHours.LastAllocationHours,2)}
                            </td>
                            <td style={{textAlign:'center'}}>
                            {FormatInvoiceDecimalNumber(cultureInfoName.toString(),taskRequestHours.NewAllocationHours,2)}
                            </td>
                            <td style={{textAlign:'center'}}>
                            {renderStatusExpenseEntries(taskRequestHours)}
                            {/* {taskRequestHours.Status} */}
                            </td>         
                        </tr>
                    ))}
                </tbody>
            </table>
            {taskRequestHoursList.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found',dispatch, t)}
                                    </p>
                            </div>
                        }
        </>
    )

}

export default TaskRequestHoursItem